import { FC, useEffect, useState } from 'react';
import EfSwiperLevel2 from '@elem/ui/ef-swiper-level2';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.EnergizeElectricity');
    const PC_list = [
        {
            desc: `Dedicated NEMA TT-30R port for powering RVs.`,
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718790244088/11.jpg',
            h5List: [
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718799986988/a1.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718800000848/a2.jpg',
            ],
        },
        {
            desc: 'Perfect for any on-site DIY project with robust power and large expandable capacity.',
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718886954516/a1.jpg',
            h5List: [
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718800038947/c1.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718800053046/c2.jpg',
            ],
        },
        {
            desc: 'Enjoy clean, oil-free and smokeless power, perfect for any adventure.',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726796202368/d3.jpg',
            h5List: [
                'https://websiteoss.ecoflow.com/upload/image/1727579417599/au-sc7.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718800077140/d2.jpg',
            ],
        },
    ];
    return (
        <div className={`${css.thecomp} GtmModuleData-section`} data-section-id={'dp3-H'} data-section-title={t('title')}>
            <div className="comp-module">
                <div className="dp3-title">{t('title')}</div>
            </div>
            <EfSwiperLevel2 list={PC_list} hasLevel2={true} />
        </div>
    );
};

export default TheComp;
